import React from 'react';
import ReactDOM from "react-dom";
import closeImg from "../images/close.png";

const ErrorModal = (props) => {
    const { modal, setModal, errorMessage } = props;
    return ReactDOM.createPortal(
        <React.Fragment>
            <div
                className={"modal fade" + (modal ? "show " : "")}
                id="errorModal"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                role="dialog"
                style={modal ? { display: "block" } : { display: "none" }}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body d-flex justify-content-center space-12">
                            <div className="p-2">
                                <span className='text-danger'>{errorMessage}</span>
                            </div>

                        </div>
                        <div className="modal-footer">
                            <div className="col d-flex justify-content-end align-items-end ">
                                <button
                                    onClick={() => setModal(false)}
                                    autoFocus
                                    className="btn btn-md btn-secondary d-flex align-items-center px-4 fw-medium text-white rounded-3 mx-1"
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {modal ? <div className="modal-backdrop fade show" /> : ""}
        </React.Fragment>,
        document.getElementById("modal-root")
    );
}

export default ErrorModal
